<template>
	<div class="hairInfo">
		<div style="margin-left: 20px">
			<h3 class="el-tabs-pane-nav">新建发型师
				<el-button type="primary" class="nav-bar-btns-item" @click="typeShow=true"><span class="red">* </span>
					职业变动
				</el-button>
			</h3>
			<div class="nav-bar-btns" style="display: flex;margin-top: -20px;">
				<div>是否试工:</div>
				<div style="margin-top: 1px;margin-left: 6px;">
					<el-radio v-model="form.test" :label="0">否</el-radio>
					<el-radio v-model="form.test" :label="1">是</el-radio>
				</div>
			</div>
			<el-form ref="form" label-position="left" :model="form" label-width="85px">
				<div style="margin-bottom: 20px" v-if="form.id">工号：{{ form.id }}</div>
				<div class="el-tabs-pane-user">
					<upload class="el-tabs-pane-upload" ref="sss" v-model="form.avatar" />
					<div class="el-tabs-pane-upload-item">
						<div style="font-weight: 500;" v-if="form.id">当前状态</div>
						<span class="red">* </span>
						<el-button class="el-tabs-pane-upload-item-butupload" type="primary" plain
							@click="butupload">上传图片</el-button>
						<div class="el-tabs-pane-upload-item-tetx">点击图片上传，建议尺寸500*500或1:1，jpg\png格式，图片小于1M</div>
					</div>
					<div class="el-tabs-pane-upload-item1">
						<el-form-item label="姓名">
							<div class="flex">
								<span class="red">* </span>
								<el-input v-model="form.name"></el-input>
							</div>
						</el-form-item>
						<el-form-item label="性别">
							<span class="red">* </span>
							<el-radio-group v-model="form.sex">
								<el-radio label="男" value="男性"></el-radio>
								<el-radio label="女" value="女性"></el-radio>
							</el-radio-group>
						</el-form-item>
						<el-form-item label="学历">
							<el-select v-model="form.education" placeholder="请选择您学历">
								<el-option label="本科" value="本科"></el-option>
								<el-option label="专科" value="专科"></el-option>
								<el-option label="中专" value="中专"></el-option>
								<el-option label="高中" value="高中"></el-option>
								<el-option label="其他" value="其他"></el-option>
							</el-select>
						</el-form-item>
					</div>
					<div class="el-tabs-pane-upload-item2">
						<el-form-item label="英文名">
							<div class="flex">
								<span class="red">* </span>
								<el-input v-model="form.nameEn"></el-input>
							</div>
						</el-form-item>
						<el-form-item label="手机号">
							<div class="flex">
								<span class="red">* </span>
								<el-input v-model="form.telphone"></el-input>
							</div>
						</el-form-item>
						<el-form-item label="婚姻状况">
							<el-select v-model="form.marry" placeholder="请选择您婚姻情况">
								<el-option label="已婚" value="已婚"></el-option>
								<el-option label="未婚" value="未婚"></el-option>
							</el-select>
						</el-form-item>
					</div>
					<div class="el-tabs-pane-upload-item3">
						<el-form-item label="入职时间">
							<el-date-picker type="date" placeholder="选择日期" v-model="form.joinTime" style="width: 100%;"
								value-format="yyyy-MM-dd"></el-date-picker>
						</el-form-item>
						<el-form-item label="身份证">
							<el-input v-model="form.idcard"></el-input>
						</el-form-item>
						<el-form-item label="显示价格" placeholder="设置小程序显示价格">
							<div class="flex">
								<span class="red">* </span>
								<el-input v-model="form.maxPrice">
									<template slot-scope="scope">
										{{scope.row.maxPrice/100}}
									</template>
								</el-input>
							</div>
						</el-form-item>
					</div>
				</div>
				<div class="el-tabs-pane-address">
					<div class="el-tabs-pane-address-left" style="width:750px;">
						<el-form-item class="address-left-td" label="居住地址">
							<el-cascader v-model="form.city" style="width: 120px; margin-right:20px ;" :options="addrs"
								clearable></el-cascader>
							<el-input v-model="form.addressDetail" style="width: 300px" placeholder="输入详细地址"></el-input>
						</el-form-item>
						<div class="flex">
							<el-form-item class="address-left-td" label="户口性质">
								<el-select style="width: 120px; margin-right:20px ;" v-model="form.accountNature"
									placeholder="城市">
									<el-option label="城市" :value="1"></el-option>
									<el-option label="农村" :value="2"></el-option>
								</el-select>
							</el-form-item>
							<el-form-item style="width: 300px;" class="address-left-th" label="办理健康证">
								<el-radio-group v-model="form.healthy">
									<el-radio label="是"></el-radio>
									<el-radio label="否"></el-radio>
								</el-radio-group>
							</el-form-item>
						</div>
					</div>
					<div class="el-tabs-pane-address-right" style="flex: 1;">
						<el-form-item class="address-left-td" label="户口地址">
							<el-cascader v-model="form.homeAddress" style="width: 120px; margin-right:20px ;"
								:options="addrs" clearable></el-cascader>
							<el-input v-model="form.homeAddressDetail" style="width: 400px" placeholder="输入详细地址">
							</el-input>
						</el-form-item>
						<div>
							<span style="font-size: 14px;color: #606266;line-height: 40px;">紧急联系人电话</span>
							<el-input v-model="form.linkmanTelphone" style=" width:300px; margin-left: 20px;"
								placeholder="输入电话"></el-input>
						</div>
					</div>
				</div>
				<el-divider></el-divider>
				<div class="el-tabs-pane-salary">
					<div class="salary-td">薪酬信息</div>
					<!-- <div class="salary-th">
						<el-form-item label="开户银行">
							<el-input style="width: 250px;" v-model="form.bankName" placeholder="输入文字"></el-input>
						</el-form-item>
						<el-form-item class="salary-th-item" label="开户卡号" label-width="100px">
							<el-input style="width: 250px;" v-model="form.bankNumber" placeholder="输入文字"></el-input>
						</el-form-item>
					</div> -->
					<div class="salary-th">
						<el-form-item label="底薪">
							<div class="flex">
								<span class="red">* </span>
								<el-input style="width: 250px;" v-model="form.baseSalary" placeholder="输入文字"></el-input>
							</div>
						</el-form-item>
						<el-form-item class="salary-th-item" label="月度绩效考核" label-width="100px">
							<el-input style="width: 250px;" v-model="form.monthMerits " placeholder="输入文字"></el-input>
						</el-form-item>
					</div>
					<div class="salary-th">
						<el-form-item label="业绩提成">
							<el-input style="width: 240px;" v-model="form.commissionRatio"
								placeholder="百分比"></el-input>%
						</el-form-item>
						<el-form-item class="salary-th-item" label="级别奖励比例" label-width="100px">
							<el-input style="width: 240px;" v-model="form.levelRatio" placeholder="百分比"></el-input>%
						</el-form-item>
					</div>
<!--					<span style="font-size:14px;color:#bbb">除美团外其他业绩计算方式跟门店业绩设置</span>-->
<!--					<div class="salary-th">-->
<!--						<el-form-item label="美团业绩">-->
<!--							<el-radio-group v-model="form.performanceType">-->
<!--								<el-radio :label="0">服务价格</el-radio>-->
<!--								<el-radio :label="1">实收</el-radio>-->
<!--							</el-radio-group>-->
<!--						</el-form-item>-->
<!--					</div>-->
<!--					<div class="salary-th">-->
<!--						<el-form-item label="套餐业绩">-->
<!--							<el-radio-group v-model="form.isMemberCommission">-->
<!--								<el-radio :label="0">计入业绩</el-radio>-->
<!--								<el-radio :label="1">不计入</el-radio>-->
<!--							</el-radio-group>-->
<!--						</el-form-item>-->
<!--					</div>-->
<!--					<div class="salary-th">-->
<!--						<el-form-item label="是否兼职发型师">-->
<!--							<el-radio-group v-model="form.isPartTime">-->
<!--								<el-radio :label="1">是</el-radio>-->
<!--								<el-radio :label="0">否</el-radio>-->
<!--							</el-radio-group>-->
<!--						</el-form-item>-->
<!--					</div>-->
					<el-divider></el-divider>
					<div class="el-tabs-pane-major">
						<div class="major-td" style="margin-bottom: 20px;"><span
								style="font-family: SourceHanSansCN-Bold;">{{form.name}}</span><span
								style="margin-left: 10px;">专业信息</span></div>
						<div class="major-th">
							<el-form-item label="所属门店" style="margin-right: 50px;">
								<span class="red">* </span>
								<el-select v-model="form.storeId" placeholder="请选择所属门店" @change="getRoster" size="small"
									style="width: 200px;">
									<el-option v-for="item in stores" :key="item.id" :label="item.title"
										:value="item.id">
									</el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="行业资历">
								<el-input :controls="false" style="width: 250px; padding-right: 10px;"
									v-model="form.social" placeholder="输入文字"></el-input>年
							</el-form-item>
							<!-- <el-form-item style="margin-left: 50px;" label="所属班次">
                <el-select v-model="form.rosterId" no-data-text="请选择门店" placeholder="请选择所属班次">
                  <el-option
                    v-for="item in rosters"
                    :key="item.id"
                    :label="item.desc"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item> -->
              <el-form-item style="margin-left: 50px;" label="上下班权限">
                <el-switch
                    v-model="form.commutePermission"
                    active-text="可设置"
                    inactive-text="不可设置"
                    :active-value="1"
                    :inactive-value="0"
                >
                </el-switch>
              </el-form-item>
              <el-form-item style="margin-left: 50px;" label="业绩权限">
                <el-switch
                    v-model="form.commissionPermission"
                    active-text="具备"
                    inactive-text="不具备"
                    :active-value="1"
                    :inactive-value="0"
                >
                </el-switch>
              </el-form-item>
						</div>
						<div class="major-th" v-if="form.id">
              <el-form-item label="代取号权限">
                <el-switch
                  v-model="form.taskNumPermission"
                  active-text="可代取"
                  inactive-text="不可代取"
                  :active-value="1"
                  :inactive-value="0"
                >
                </el-switch>
              </el-form-item>
              <el-form-item style="margin-left: 50px;" label="每日代取数">
                <el-input v-model="form.taskNum" placeholder="输入订单数" type="number"></el-input>
              </el-form-item>
							<el-form-item style="margin-left: 50px;" label="排班权限门店" label-width="100px">
								<el-select v-model="form.authorityStoreId" placeholder="请选择可排班门店" @change="getRoster"
									size="small" style="width:200px;">
									<el-option v-for="item in stores" :key="item.id" :label="item.title"
										:value="item.id">
									</el-option>
								</el-select>
								<!-- 追加id -->
								<el-button class="bottom-item" type="primary" @click="saveOrUpdateWorkerAuthority()">
									确定</el-button>
							</el-form-item>
							<el-form-item>
								<!-- 发型师ID，门店ID -->
								<el-tag closable v-for=" i in authoritys" @close="delArrangeStore(i.workerId,i.storeId)"
									class="tag1">{{i.storeName}}
								</el-tag>
							</el-form-item>
						</div>

					</div>
				</div>
				<!--<div style="margin-top: 40px;" class="el-tabs-pane-evaluate">
          <div style="margin-bottom: 20px;" class="evaluate-td">导师评价</div>
          <div class="evaluate-th">
            <el-input
              type="textarea"
              placeholder="请输入内容"
              v-model="form.remark"
              maxlength="500"
              show-word-limit
              style="width: 600px; margin-bottom: 60px;"
              rows="10"
            ></el-input>
          </div>
        </div> -->
				<div class="el-tabs-pane-bottom" v-if="showType != 'query'" style="padding: 20px; margin-top: 30px;  text-align: center; background-color: #F2F6FC">
					<el-button class="bottom-item" plain @click="$router.push('/hairlist')">取消</el-button>
					<el-button class="bottom-item" type="primary" style="margin-left: 20px;" @click="saveOrEdit">保存
					</el-button>
				</div>
			</el-form>
		</div>
		<div>
			<el-dialog title="职位变动" :visible.sync="typeShow" width="30%">
				<el-form>
					<el-form-item label="发型师等级" label-width="100px">
						<el-select v-model="form.type">
							<el-option v-for="item in types" :key="item.value" :label="item.label" :value="item.value">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="发型师级别" label-width="100px">
						<el-select v-model="form.levelId">
							<el-option v-for="item in levels" :key="item.id" :label="item.title" :value="item.id">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item style="position: relative;top:20px; left: 60%;">
						<el-button type="primary" @click="typeShow=false">确认</el-button>
					</el-form-item>
				</el-form>
			</el-dialog>
		</div>
	</div>
</template>

<script>
	import upload from "../../compents/upload/upload";
	export default {
		name: "hairInformation",
		components: {
			upload,
		},
		data() {
			return {
				enter: false,
				showType: "",
				addrs: [],
				stores: [],
				rosters: [],
				authoritys: [],
				typeShow: false,
				types: [{
					label: "店员",
					value: 0,
				}, {
					label: "店长",
					value: 1,
				}, {
					label: "试用期",
					value: 2,
				}, ],
				levels: [],
				form: {
					id: undefined,
					jobId: undefined,
					name: undefined,
					nameEn: undefined,
					avatar: undefined,
					telphone: undefined,
					username: undefined,
					password: undefined,
					type: undefined,
					storeId: undefined,
					authorityStoreId: undefined,
					storeName: undefined,
					rosterId: undefined,
					rosterDesc: undefined,
					status: undefined,
					isRemove: undefined,
					isPartTime: undefined,
					province: undefined,
					city: undefined,
					cityCode: undefined,
					addressDetail: undefined,
					salaryProbation: undefined,
					salary: undefined,
					baseSalary: undefined,
					monthMerits: undefined,
					probationTime: undefined,
					levelRatio: undefined,
					commissionRatio: undefined,
					joinTime: undefined,
					leaveTime: undefined,
					birth: undefined,
					personType: undefined,
					idcard: undefined,
					idcardAddressCode: undefined,
					idcardAddress: undefined,
					idcardAddressDetail: undefined,
					education: undefined,
					marry: undefined,
					social: undefined,
					healthExpire: undefined,
					healthCertificate: undefined,
					bankName: undefined,
					bankNumber: undefined,
					socialCom: undefined,
					socialPerson: undefined,
					accumulationCom: undefined,
					accumulationPeson: undefined,
					contractExpire: undefined,
					sex: undefined,
					homeAddress: undefined,
					homeAddressCode: undefined,
					homeAddressDetail: undefined,
					accountNature: undefined,
					linkmanName: undefined,
					linkmanTelphone: undefined,
					joinStep: undefined,
					seniority: undefined,
					nickName: undefined,
					avatarUrl: undefined,
					remark: undefined,
					workerStatus: undefined,
					aboutTime: undefined,
					rankPerfix: undefined,
					fugoulv: undefined,
					fugoulvExpire: undefined,
					vacation: undefined,
					addPrice: undefined,
					addPriceService: undefined,
					sessionId: undefined,
					levelId: undefined,
					levelTitle: undefined,
					maxPrice: undefined,
					test: 0,
					performanceType:0,
					isMemberCommission:0,
          commutePermission:1,
          commissionPermission:0,
          taskNumPermission:0,
          taskNum:1
				},
			};
		},
		mounted() {
			this.form.id = this.$route.query.id;
			this.getcity();
			this.getStore();
			this.getLevels();
			if (this.form.id) {
				this.getWorker();
				this.getAuthority();
			}
		},
		created() {
			window.addEventListener("keydown", this.handleKeyDown)
		},
		methods: {
			getAuthority() {
				var a = {
					workerId: this.form.id
				}
				this.$http.get("dWorkerAuthority/workerAuthorityList", {
					params: a
				}, {
					emulateJSON: true
				}).then(res => {
					if (res.body.code == "200") {
						this.authoritys = res.body.data;
					}
				})
			},
			saveOrUpdateWorkerAuthority() {
				if (this.form.authorityStoreId != null && this.form.authorityStoreId != '') {
					var b = {
						type: 0,
						workerId: this.form.id,
						storeId: this.form.authorityStoreId
					}
					this.$http.post("dWorkerAuthority/addOrUpdate", JSON.stringify(b)).then(res => {
						if (res.body.code == "200") {
							if (res.body.data.status == 1) this.$message.success("已添加")
							this.getAuthority()
						}
					})
				}
			},
			delArrangeStore(workerId, storeId) {
				var c = {
					type: 0,
					workerId: workerId,
					storeId: storeId
				}
				this.$http.post("dWorkerAuthority/addOrUpdate", JSON.stringify(c)).then(res => {
					if (res.body.code == "200") {
						if (res.body.data.status == 0) this.$message.success("已删除")
						this.getAuthority()
					}
				})
			},
			butupload() {
				document.querySelector(".el-upload--picture-card").click();
			},
			getLevels() {
				this.$http.get("dWorkerLevel/query").then(res => {
					this.levels = res.body.data;
				})
			},
			getcity() {
				const provinces = require('province-city-china/dist/province.json');
				const citys = require('province-city-china/dist/city.json');
				provinces.forEach(res => {
					let child = [];
					citys.forEach(c => {
						if (res.province == c.province) {
							c.label = c.value = c.name;
							child.push(c)
						}
					})
					if (child.length == 0) {
						child[0] = {
							label: res.name,
							value: res.name,
						}
					}
					res.label = res.value = res.name;
					res.children = child;
				})
				this.addrs = provinces;
			},
			getRoster() {
				if (this.form.storeId) {
					let data = JSON.stringify({
						storeId: this.form.storeId,
						pageNum: 1,
						pageSize: 1000
					})
					this.$http.post("dcheckuser/findDRosterData", data).then(res => {
						this.rosters = res.body.data
					})
				}
			},
			getStore() {
				this.$http.get("store/list").then(res => {
					res.body.data = res.body.data.filter(ele => ele.businessType == 0)
					this.stores = res.body.data
				})
			},
			// handleKeyDown(e) {
			// 	if (e.keyCode === 13) {
			// 		this.saveOrEdit()
			// 	}
			// },
			saveOrEdit() {
				if(this.form.baseSalary==undefined){
					this.$message.error("请填写底薪")
				}else{
					this.stores.forEach(s => {
						if (s.id == this.form.storeId) this.form.storeName = s.title
					})
					this.rosters.forEach(s => {
						if (s.id == this.form.rosterDesc) this.form.rosterDesc = s.desc
					})
					if (this.form.city) {
						this.form.province = this.form.city[0];
						this.form.city = this.form.city[1];
					}
					if (this.form.homeAddress) {
						this.form.homeAddress = this.form.homeAddress[0] + (this.form.homeAddress[0] == this.form.homeAddress[
								1] ? '' : "," +
							this.form.homeAddress[1]);
					}
					this.levels.forEach(l => {
						if (l.id == this.form.levelId) this.form.levelTitle = l.title;
					})
					this.form.maxPrice = this.form.maxPrice * 100

					if (this.form.test == 1) { //试工，发型师名字加上C
						if (this.form.name != null && this.form.name.substr(0, 1).indexOf("C") == -1) {
							this.form.name = "C" + this.form.name
						}
					} else { //正职,发型师名字去掉C
						if (this.form.name != null && this.form.name.substr(0, 1).indexOf("C") == false) {
							this.form.name = this.form.name.substr(1, 20)
						}
					}
					let data = JSON.stringify(this.form)
					this.$http.post("dWorker/edit", data).then(res => {
						if (res.body.code == 1000) {
							this.$message.error(res.body.msg)
						} else {
							this.$message.success("编辑/保存成功")
							this.$router.push("/hairlist")
						}
					})
				}

			},
			getWorker() {
				this.$http.get("dWorker/query/" + this.form.id).then(res => {
					Object.keys(this.form).forEach(key => {
						this.form[key] = res.body.data[key]
					})
					this.form.city = [this.form.province, this.form.city]
					this.form.maxPrice = (this.form.maxPrice / 100).toFixed(2)
					// this.form.test = res.body.data.test
					if (this.form.homeAddress) {
						this.form.homeAddress = this.form.homeAddress.split(",")
						if (this.form.homeAddress.length == 1) this.form.homeAddress[1] = this.form.homeAddress[0]
					}
					this.getRoster();
				})
			},
			destroyed() {
				window.removeEventListener("keydown", this.handleKeyDown, false)
			}
		},
	}
</script>

<style>
	.tag1 {
		color: #000;
		margin: 5px;
		background-color: #f2f2f2;
		/* border: #343434; */
		/* border: 1px; */
		/* padding: px; */
	}

	.red {
		color: red;
	}

	.flex {
		display: flex;
	}

	.nav-bar-btns {
		position: absolute;
		top: 60px;
		right: 20px;
	}

	.nav-bar-btns-item {
		padding: 8px 15px;
		margin: 0 20px;
	}

	.el-tabs-pane-nav {
		position: relative;
		padding-left: 15px;
	}

	.el-tabs-pane-nav::before {
		content: " ";
		height: 20px;
		width: 6px;
		display: block;
		position: absolute;
		top: 3px;
		left: 0;
		background: #449bfb;
		border-radius: 2px;
	}

	.el-tabs-pane-upload {
		width: 130px;
		height: 117px;
	}

	.el-tabs-pane-upload-item,
	.el-tabs-pane-upload-item1 {
		margin-left: 20px;
	}

	.el-tabs-pane-user {
		display: flex;
	}

	.el-tabs-pane-upload-item-butupload {
		padding: 10px;
	}

	.el-tabs-pane-upload-item-tetx {
		font-size: 12px;
		width: 150px;
		margin-top: 5px;
		color: #d3d2d5;
	}

	.el-input__inner {
		height: 32px;
	}

	.el-form-item {
		margin-bottom: 5px;
	}

	.el-tabs-pane-upload-item2,
	.el-tabs-pane-upload-item3 {
		margin-left: 100px;
	}

	.el-tabs-pane-address {
		display: flex;
		margin-top: 40px;
	}

	.el-select-dropdown {
		max-width: 200px;
	}

	.address-left-td .el-form-item__content {
		display: flex;
	}

	.address-left-th .el-form-item__label {
		padding: 0;
		margin: 0 40px;
	}

	.salary-td {
		margin-bottom: 20px;
	}

	.salary-th {
		display: flex;
	}

	.salary-th-item {
		margin-left: 40px;
	}

	.major-th {
		/* width: 50%; */
		display: flex;
	}

	.bottom-item {
		margin-left: 5px;
		padding: 8px 15px;
	}

	.hairInfo .el-dialog {
		border-radius: 20px;
	}

	.hairInfo .el-dialog__title {
		display: block;
		position: relative;
		padding-left: 12px;
	}

	.hairInfo .el-dialog__title::before {
		content: " ";
		height: 20px;
		width: 6px;
		display: block;
		position: absolute;
		top: 3px;
		left: 0;
		background: #449bfb;
		border-radius: 2px;
	}
</style>
